module.exports = __webpack_public_path__ + "img/_close.bd6b343d.svg";